import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { CircularProgress, useTheme } from '@mui/material';
import { toastError } from 'src/Toaster/Toast';

export const ActionButtons: React.FC<{
	confirmCallback: () => Promise<any>;
	cancelCallback?: () => void;
	confirmButtonStyle: 'success' | 'warning';
	confirmButtonText: string;
	confirmDisabled?: boolean;
}> = ({
	confirmCallback,
	cancelCallback,
	confirmButtonText,
	confirmDisabled,
}) => {
	const theme = useTheme();
	const [loading, setLoading] = useState(false);

	return (
		<Stack direction="row" spacing={2} flexWrap="wrap">
			<Button
				variant="outlined"
				color='error'
				style={{ minWidth: 100 }}
				onClick={cancelCallback}
			>
				Cancel
			</Button>
			<Button
				variant="contained"
				style={{ minWidth: 100 }}
				disabled={loading || confirmDisabled}
				onClick={async () => {
					setLoading(true);
					try {
						const res = await confirmCallback();
						if (res?.errored) {
							toastError({
								title: 'Action Failed',
								description: res?.message || 'An unknown error occurred',
							})
						}
					} catch (error) {
						console.log(error);
					} finally {
						setLoading(false);
					}
				}}
			>
				{loading ? (
					<>
						<CircularProgress
							size={theme.spacing(2)}
							color="inherit"
							style={{ marginRight: 8 }}
						/>
						Processing...
					</>
				) : (
					confirmButtonText
				)}
			</Button>
		</Stack>
	);
};
